import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {concat, Observable, of, ReplaySubject} from "rxjs";
import {catchError, delay, filter, first, take, takeUntil, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FileResult} from "../../../../shared/components/bills-file-drag-and-drop/bills-file-drag-and-drop.component";
import {InvoiceService} from "../../../../shared/services/invoice.service";
import * as uuid from 'uuid';
import {Invoice} from "../../../../shared/interface/invoice";
import {
  INVOICE_STATUS_PAID,
  INVOICE_STATUS_SENT_FOR_PAYMENT,
  INVOICE_STATUS_TO_BE_CORRECTED
} from '../../../../shared/services/dict.service';
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {ConfirmDialogComponent} from "../../../../shared/components/confirm-dialog/confirm-dialog.component";
import {MassEditionDialogComponent} from "../../mass-edition-dialog/mass-edition-dialog.component";
import {Contract} from "../../../../shared/interface/contract";
import {validIban} from "../../../../shared/validator/iban-validator";
import {Ofwca} from "../../../../shared/interface/ofwca";
import {CommissionSettlementService} from "../../../../shared/services/commission-settlement.service";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {CommissionSettlement} from "../../../../shared/interface/commission-settlement";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {InfoDialogComponent} from "../../../../shared/components/info-dialog/info-dialog.component";

@Component({
  selector: 'app-add-bills',
  templateUrl: './add-bills.component.html',
  styleUrls: ['./add-bills.component.scss']
})
export class AddBillsComponent implements OnInit, OnDestroy  {

  readonly INVOICE_STATUS_TO_BE_CORRECTED = INVOICE_STATUS_TO_BE_CORRECTED;
  readonly INVOICE_STATUS_SENT_FOR_PAYMENT = INVOICE_STATUS_SENT_FOR_PAYMENT;
  readonly INVOICE_STATUS_PAID = INVOICE_STATUS_PAID;

  invoiceObject: Invoice;

  errors: any = {};

  billFormVaild = false;
  modifyInvoice = false;
  modifyInvoiceContract = false;
  modifyContractSettlement = false;
  modifyAccountNumber = false;
  enableSaveButton = false;
  billingMonthControl: FormControl;
  serviceDateControl: FormControl;
  billForm: FormGroup;
  invoiceForm: FormGroup;
  numberControl: FormControl;
  selectedBillingMonth: FormControl;
  grossControl: FormControl;
  netControl: FormControl;
  balanceControl: FormControl;
  sellerAccountNumberControl: FormControl;
  issueDateControl: FormControl;
  contractControl: FormControl;
  settlementsSubject: ReplaySubject<CountedAndPaginated<CommissionSettlement>>
    = new ReplaySubject(1);
  settlementsSubjectSecond: ReplaySubject<CountedAndPaginated<CommissionSettlement>>
    = new ReplaySubject(1);
  commissionSettlement: any;
  commissionSettlementControl: FormControl;
  settlements: CommissionSettlement[] = [];
  settlementsUuid:  CommissionSettlement[] = [];
  selectedBillingMonthData = [];
  fileControl: FormControl;
  processingRequest = false;
  processingRequestInvoice = false;
  formErrors = {};
  fileResults: FileResult[] = [];
  addFile = false;
  deleteInvoiceObject: ReplaySubject<any> = new ReplaySubject<any>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  addInitialBalanceButton = true;
  invoiceFileResult: ReplaySubject<Invoice> = new ReplaySubject<Invoice>(1);
  invoiceObjectReturn: ReplaySubject<any> = new ReplaySubject<any>(1);
  invoiceObjectIndex: number;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private invoiceService: InvoiceService,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private commissionSettlementService: CommissionSettlementService,
  ) {
    this.billForm = fb.group({
      file: this.fileControl = fb.control('', [Validators.required]),
      billingMonth: this.billingMonthControl = fb.control(''),

    });

    this.invoiceForm = this.fb.group({
      billingMonth: this.billingMonthControl = fb.control(''),
      serviceDate: this.serviceDateControl = fb.control(''),
      selectedBillingMonth: this.selectedBillingMonth = fb.control(''),
      number: this.numberControl = fb.control('', [Validators.required]),
      gross: this.grossControl = fb.control('', [Validators.required]),
      net: this.netControl = fb.control('', [Validators.required]),
      initialBalance: this.balanceControl = fb.control('', ),
      createdAt: this.issueDateControl = fb.control('', [Validators.required]),
      contract: this.contractControl = fb.control('', [Validators.required]),
      sellerAccountNumber: this.sellerAccountNumberControl = fb.control('', [Validators.required, validIban()]),
    });
    const activeToDate = new Date();
    activeToDate.setMonth(activeToDate.getMonth() - 1);
    this.billingMonthControl.setValue(activeToDate);
  }

  ngOnInit(): void {
    this.billForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.billFormVaild = this.billForm.valid;
      });

    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: File[]) => !!file)
      )
      .subscribe(() => {
        this.fileResults = [];
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.billForm, this.formErrors);
    this.formErrors = {};
    this.fileResults = [];
    this.billFormVaild = false;

    const forms: Observable<any>[] = [];

    this.fileControl.value?.forEach((file: File, index: number) => {
      const reader = new FileReader();
      const activeToDate = new Date();
      const uuidV4 = uuid.v4();

      activeToDate.setMonth(activeToDate.getMonth() - 1);

      reader.readAsDataURL(file);

      reader.onload = () => {
        forms.push(
          this.invoiceService.decodeBillAdd({
            fileContents: (/base64,(.+)/.exec(reader.result.toString())[1]),
            fileNames: file.name,
            uuid: uuidV4,
            billingMonth: activeToDate
          }).pipe(
            tap(
              () => {
                this.invoiceService.get(uuidV4)
                  .pipe()
                  .subscribe(
                    (invoice) => {
                      this.invoiceFileResult.next(invoice);

                      this.fileResults[index] = {
                        file,
                        result: true,
                        uuid: uuidV4,
                      };

                      this.snack.open('Dodano rachunek', '', {
                        duration: 2000,
                      });
                    },
                    (error: HttpErrorResponse) => {
                      this.fileResults[index] = {
                        file,
                        result: false,
                        uuid: uuidV4,
                        errorText: 'Nie udało się pobrać dodanego rachunku',
                      };
                    }
                  );

                this.addFile = true;
              },
              (error: HttpErrorResponse) => {
                this.fileResults[index] = {
                  file,
                  result: false,
                  uuid: uuidV4,
                  errorType: error.error?.error?.list?.errorType,
                  errorText:
                    error.error?.error?.text
                    ?? error.error?.message
                    ?? error.message
                    ?? 'Nie udało się dodać rachunku',
                };
              }
            ),

            catchError(() => of(null))
          )
        );

        if (forms.length === this.fileControl.value.length) {
          concat(...forms)
            .subscribe(
              () => {
                this.processingRequest = false;
              },
              (error: HttpErrorResponse) => {
                this.errors = error.error?.error?.list;

                this.formHelper.setBackendErrorState(
                  this.invoiceForm,
                  this.errors
                );

                this.processingRequest = false;

                this.snack.open(
                  error.error?.error?.text,
                  error.status.toString(),
                  {duration: 2000}
                );
              }
            );
        }
      };
    });
  }

  selectedInvoice(event): void {
    if (event.delete){
      this.modifyInvoice = false;
      this.invoiceObject = null;
      return;
    }
    this.processingRequestInvoice = true;
    this.invoiceObjectIndex = event.index;
    this.invoiceService.get(event.invoice?.id)
      .pipe()
      .subscribe((response) => {
        if (response) {
          this.processingRequestInvoice = false;
          this.invoiceObject = response;
        }
        // if (response.settlements.length > 0){
        //   this.modifyContractSettlement = true;
        // }

      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy pobraniu rachunku wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }
  cancel(): void {
    this.modifyInvoice = false;
  }
  reload(): void {
    window.location.reload();
  }
  delete(invoice: Invoice): void {
    this.modifyInvoice = false;
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć fakturę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.invoiceService.delete(invoice.id)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto fakturę', '', {duration: 2000});
              // this.router.navigate(['/faktury']);
              this.deleteInvoiceObject.next({invoice: invoice.uuid, index: this.invoiceObjectIndex});
              this.invoiceObject = null;
            },
            error: (error: HttpErrorResponse) => {
              this.snack.open('Nie można usunąć faktury', error.status.toString(), {duration: 2000});
            }
          });
      }
    });
  }

  modify(invoice: Invoice): void {
    this.modifyInvoice = true;
    if (invoice) {
      const activeToDate = new Date();
      activeToDate.setMonth(activeToDate.getMonth() - 1);
      this.billingMonthControl.setValue(activeToDate);
      this.numberControl.setValue(invoice?.number);
      this.selectedBillingMonth.setValue(this.selectedBillingMonthData);
      this.grossControl.setValue(invoice?.gross);
      this.netControl.setValue(invoice?.payoutNet);
      this.issueDateControl.setValue(invoice?.issueDate);
      this.serviceDateControl.setValue(invoice?.serviceDate);
      this.contractControl.setValue(invoice?.contract);
      if (invoice.contract !== null){
        this.modifyInvoiceContract = true;
        this.contractControl.setValue(invoice?.contract.uuid);
      }
      if (invoice.sellerAccountNumber !== null) {
        this.sellerAccountNumberControl.setValue(invoice?.sellerAccountNumber);
      } else {
        this.contractChanged(invoice?.contract);
      }
      this.settlementsSubject
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response) => {
          // this.settlements = response.items;
          this.commissionSettlement = response.items;
        });
      this.settlementsSubjectSecond
        .pipe(takeUntil(this.destroyed$))
        .subscribe((response) => {
          this.settlements = response.items;
          this.settlements.forEach((settlementsResponse) => {
            settlementsResponse.contractSettlements.forEach((contracSettlementsResponse) => {
              contracSettlementsResponse.invoices.sort((a, b) =>
                new Date(a.invoice.createdAt).getTime() - new Date(b.invoice.createdAt).getTime());
            });
          });
        });

    }
  }

  shownInvoice(invoice: Invoice): void {
   this.dialog.open(InfoDialogComponent, {
      width: '50vw',
      data: {
        text: 'Podgląd skanu',
        body: invoice.decodeBill
      },
    });
  }

  initialize(invoice: Invoice): void{
    of(invoice)
      .pipe(
        tap(() => {
          this.invoiceForm.reset({
            billingMonth: invoice.billingMonth,
            number: invoice.number,
            gross: invoice.gross,
            net: invoice.net,
            initialBalance: invoice.initialBalanceNet,
            issueDate: invoice.issueDate,
            createdAt: invoice.issueDate,
            contract: invoice.contract,
            sellerAccountNumber: invoice.sellerAccountNumber,
          });
        }),
        delay(0),
        tap(() => {
          this.invoiceForm.markAllAsTouched();
        })
      ).subscribe();
  }

  contractChanged(contract: Contract): void {
    const filters: any = {
      onlyNew: 1,
      contract: contract?.uuid,
    };
    this.commissionSettlementService.loadList(
      0,
      10,
      filters,
      this.settlementsSubject
    );
    if (contract?.partner){
      this.sellerAccountNumberControl.setValue(contract?.partner?.accountNumber);
    } else {
      this.sellerAccountNumberControl.setValue(contract?.ofwca?.accountNumber);
    }
  }
  contractChangedSecond(contract: Contract): void {
    const filters: any = {
      contract: contract?.uuid,
    };
    this.commissionSettlementService.loadList(
      0,
      10,
      filters,
      this.settlementsSubjectSecond
    );
  }

  selectedCommissionSettlement(selectedCommissionSettlement): void  {
    const selected = [];
    const selectedDate = [];
    this.settlementsSubject
      .pipe(first())
      .subscribe((item) => {
        selectedCommissionSettlement.forEach((cs) => {

          const currentUuid = item.items.find((uuid) => uuid.uuid === cs);
          if (currentUuid.totalCommission > 0 ) {
            selected.push(currentUuid);
            selectedDate.push(currentUuid.billingMonth);
            this.selectedBillingMonthData.push(currentUuid.billingMonth);
          }
          const contractBalance = currentUuid.contractSettlements.find((cb) => cb.contractBalance);
          if (contractBalance.contractBalance.initialBalanceNet === 0){
            this.addInitialBalanceButton = false;
          }
        });
      });
    this.selectedBillingMonth.setValue(selectedDate);

    this.settlementsUuid = selected.sort((a: CommissionSettlement, b: CommissionSettlement) =>
      new Date(a.billingMonth).getTime() - new Date(b.billingMonth).getTime());

  }

  sendForm(id, index): void
  {
    if (!this.invoiceForm.valid) {
      this.invoiceForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.invoiceService.sendForm(this.invoiceForm.value, id)
      .pipe(first())
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie zaktualizowano rachunek', '', {
          duration: 2000,
        });
        this.modifyInvoice = false;
        this.invoiceService.get(id)
          .pipe()
          .subscribe((invoice) => {
            this.invoiceObject = invoice;
            this.invoiceObjectReturn.next({invoice, index});
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy pobraniu rachunku wystąpił błąd', error.status.toString(), {duration: 2000});
          });
      }, (error: HttpErrorResponse) => {
        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          if (error.status === 400) {
            this.snack.open(error.error.error.text, '400', {duration: 4000});
            this.formHelper.setBackendErrorState(this.invoiceForm, error.error.error.list);
          }
        }
      });
  }

}
